import { css, html, LitElement } from 'lit-element';
import style from '@giswebgroup/ki-watericons/css/external.css';
import styleMap from '@giswebgroup/ki-mapicons/css/external.css';
import fstyle from '@fortawesome/fontawesome-free/css/all.css';
import { addLinkFile } from '../../common/style';

// temp solution bug: font not work inside shadydom
// so need css style in document for fontface, in shadydom for styles
addLinkFile(style);
addLinkFile(styleMap);
addLinkFile(fstyle);

export default class KiIcon extends LitElement {
  // language=CSS
  static styles = css`
    :host {
      display: inline-block;
      box-sizing: border-box;
      line-height: 1em;
    }
  `;

  static get properties() {
    return {
      icon: { type: String, reflect: true },
    };
  }

  render() {
    return html`
      <link rel="stylesheet" href="${style}" />
      <link rel="stylesheet" href="${fstyle}" />
      <link rel="stylesheet" href="${styleMap}" />
      <i part="icon" class="${this.icon}"></i>
    `;
  }
}

customElements.define('ki-icon', KiIcon);
